module.exports = __webpack_public_path__ + "fonts/fa-regular-400.261d666b.eot";